import React from "react";
import classnames from "classnames";
import { injectIntl } from "react-intl";

import { Close, ContentCopy } from "components/Icons";

import "./style.scss";

interface IProps {
  removeBlock?: () => void;
  copyBlock?: () => void;
  showCloseBtn?: boolean;
  showCopyBtn?: boolean;
  children: any;
  className?: string;
  intl: any;
}

const BackgroundBlock = ({
  removeBlock,
  copyBlock,
  showCloseBtn,
  showCopyBtn,
  children,
  className,
  intl: { formatMessage }
}: IProps) => (
  <div className={classnames("bg-block", className)}>
    <div className="icons">
      {showCopyBtn && (
        <span title={formatMessage({ id: "DELIVERIES_COPY_LINE" })}>
          <ContentCopy className="copy-block" onClick={copyBlock} />
        </span>
      )}
      {showCloseBtn && (
        <span title={formatMessage({ id: "DELIVERIES_REMOVE_LINE" })}>
          <Close className="remove-block" onClick={removeBlock} />
        </span>
      )}
    </div>
    {children}
  </div>
);

export default injectIntl(BackgroundBlock);
